import React from 'react';
const images = {
  modules: {
    src: 'https://cdn.magicpatterns.com/uploads/pizkyEZk3RXeSHsb4sMeGj/MOCKUP_DE_MODULOS_CORRECTOS.png',
    alt: 'Megapack Maestro de Sesiones: los 6 módulos en espiral junto al volumen principal del sistema'
  },
  fullPack: {
    src: 'https://cdn.magicpatterns.com/uploads/oN4qvbT4qpUyB1FdBBNbcb/MOCKUP_GRUPAL_CORRECTO.png',
    alt: 'Megapack Maestro de Sesiones completo: el volumen principal, los 6 módulos y los 5 bonos profesionales'
  }
};
type BookStackProps = {
  className?: string;
  variant?: keyof typeof images;
};
export function BookStack({
  className = '',
  variant = 'modules'
}: BookStackProps) {
  const img = images[variant];
  return <div className={`mx-auto w-full max-w-[860px] ${className}`} data-id="element-45" data-mp="1pl9dtfym0wll">
      <img src={img.src} alt={img.alt} className="h-auto w-full mix-blend-multiply" width={1448} height={1086} data-id="element-46" data-mp="1pnvnpm8z3o6z" />
    </div>;
}